import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { BathtubBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { CageBlockView } from './CageBlockView';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/bathtub'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class BathtubBlockView extends Container {
  private _count = 0;
  private movieclip: MovieClip;

  constructor(props: BathtubBlockProps) {
    super();

    blockPositionView(this, props);

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.playAnimation('shower_state_01');
  }

  public static assets() {
    return [...Object.values(manifest()), ...CageBlockView.assets()];
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    // Count 4 = no hit, no foam
    // Count 0 = last hit, full foam
    this._count = value;

    switch (this._count) {
      case 4:
        this.playAnimation('shower_state_01');
        break;
      case 3:
        this.playAnimation('shower_transition_1_2', 'shower_state_02');
        break;
      case 2:
        this.playAnimation('shower_transition_2_3', 'shower_state_03');
        break;
      case 1:
        this.playAnimation('shower_transition_3_4', 'shower_state_04');
        break;
      case 0:
        this.playAnimation('shower_transition_4_5', 'shower_state_05');
        break;
    }
  }

  private async playAnimation(...anims: string[]) {
    // Play all animations but the last, in sequence
    const allAnimsButLast = anims.slice(0, -1);
    for (const anim of allAnimsButLast) {
      await this.movieclip.playAsync(anim);
    }
    // Last anim is looped
    const lastAnim = anims[anims.length - 1];
    this.movieclip.play(lastAnim, null, true);
  }
}
